import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import FeatureDescriptionDefault from '@/components/composite/FeatureDescription/FeatureDescriptionDefault';
import AlbumFunnelModal from '@/components/pages/albums/AlbumFunnelModal';

// Images
import illustrationEn from './../../../../../public/images/illustrations/albums/illustration-empty-albums-en.webp';

function AlbumEmpty() {
    const { t } = useTranslation();
    const { isOpen: isOpenAlbumFunnel, toggle: toggleAlbumFunnel } = useToggle();

    const data = {
        title: t('content:discover_feature.title'),
        description: t('content:discover_feature.description'),
        sections: [
            {
                title: t('content:discover_feature.section_1.title'),
                options: [
                    t('content:discover_feature.section_1.option_1'),
                    t('content:discover_feature.section_1.option_2')
                ]
            },
            {
                title: t('content:discover_feature.section_2.title'),
                options: [
                    t('content:discover_feature.section_2.option_1'),
                    t('content:discover_feature.section_2.option_2')
                ]
            }
        ],
        illustration: {
            en: illustrationEn,
            fr: illustrationEn,
            es: illustrationEn
        },
        actionButton: (
            <Button
                onClick={toggleAlbumFunnel}
                variant="secondary"
                className="create-new-add space-x-2">
                <span>{t('content:discover_feature.button')}</span>
                <Icon icon="arrow-right" />
            </Button>
        )
    };
    return (
        <div className="flex flex-1 flex-col">
            <FeatureDescriptionDefault data={data} />
            <AlbumFunnelModal isOpen={isOpenAlbumFunnel} toggle={toggleAlbumFunnel} />
        </div>
    );
}

export default AlbumEmpty;
